








































































































































































import { Component, Vue, Watch, Ref, PropSync } from 'vue-property-decorator';
import _ from 'lodash';

@Component({})
export default class BusinessTradeReferenceFrom extends Vue {
  @Ref() readonly referee1Form!: { validate: (any?: any) => Promise<boolean> };
  @Ref() readonly referee2Form!: { validate: (any?: any) => Promise<boolean> };
  @PropSync('referee1') referee1Sync!: Referee;
  @PropSync('referee2') referee2Sync!: Referee;
  @PropSync('canProceedReferee1') canProceedReferee1Sync!: boolean;
  @PropSync('canProceedReferee2') canProceedReferee2Sync!: boolean;

  @Watch('referee1Sync', { deep: true })
  watchReferee1(v) {
    this.$emit('update:referee1', v);
    this.validate();
  }

  @Watch('referee2Sync', { deep: true })
  watchReferee2(v) {
    this.$emit('update:referee2', v);
    this.validate();
  }

  @Watch('canProceedReferee1Sync')
  watchCanProceedReferee1Sync(v) {
    this.$emit('update:can-proceed-referee1', v);
  }

  @Watch('canProceedReferee2Sync')
  watchCanProceedReferee2Sync(v) {
    this.$emit('update:can-proceed-referee2', v);
  }

  async validate() {
    if (this.referee1Form && this.referee2Form) {
      if (
        !this.isEmpty(this.referee1Sync.business_name) &&
        !this.isEmpty(this.referee1Sync.abn) &&
        !this.isEmpty(this.referee1Sync.contact_full_name) &&
        !this.isEmpty(this.referee1Sync.contact_email) &&
        !this.isEmpty(this.referee1Sync.contact_phone)
      ) {
        this.canProceedReferee1Sync = await this.referee1Form.validate();
      } else {
        this.canProceedReferee1Sync = false;
      }

      if (
        !this.isEmpty(this.referee2Sync.business_name) &&
        !this.isEmpty(this.referee2Sync.abn) &&
        !this.isEmpty(this.referee2Sync.contact_full_name) &&
        !this.isEmpty(this.referee2Sync.contact_email) &&
        !this.isEmpty(this.referee2Sync.contact_phone)
      ) {
        this.canProceedReferee2Sync = await this.referee2Form.validate();
      } else {
        this.canProceedReferee2Sync = false;
      }
    }
  }

  isEmpty(v) {
    return _.isEmpty(v);
  }
}
